var dH = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
);

var currentScroll = 0;
var lastScrollTop = 0;

var toggleIndicator = true;
var slideToggleIndicator = true;

function overlayStart() {
    let wS = window.pageYOffset;
    $("body").addClass("overlay-open").attr("data-scroll-top", `${wS}px`);
}
function overlayEnd() {
    let wS = Math.abs(parseInt($("body").attr("data-scroll-top")));
    $("body").removeClass("overlay-open");
    $(window).scrollTop(wS);
}

$(document).on("click", ".js-overlay-start", function () {
    overlayStart();
});
$(document).on("click", ".js-overlay-end", function () {
    overlayEnd();
});

function resolutionCheck() {
    if ($(".i").length > 0) {
        var res = parseInt($(".i").css("width"));
        return res;
    }
}

$(".stppg").on("click", function (event) {
    event.stopPropagation();
});

$(document, '.mdl-wrap').on("click", ".js-evpd", function (event) {
    event.preventDefault();
});

$(document).on("click", "*[data-open]", function () {
    var arr = $(this).attr("data-open");
    var target = arr.split(" ");
    for (var i = 0; i < target.length; i++) {
        $("#" + target[i]).addClass("active");
        if ($("#" + target[i]).find(".styler").length) {
            setTimeout(function () {
                $(".styler").trigger("refresh");
            }, 100);
        }
    }
});

$(document).on("click", "*[data-open-temporary]", function () {
    var arr = $(this).attr("data-open-temporary");
    var target = arr.split(" ");
    $("#" + target[0]).addClass("active");
    let time = +`${target[1]}000`;
    setTimeout(() => {
        $("#" + target[0]).removeClass("active");
    }, time);
});

$(document).on("click", "*[data-close]", function () {
    var arr = $(this).attr("data-close");
    var target = arr.split(" ");
    for (var i = 0; i < target.length; i++) {
        $("#" + target[i]).removeClass("active");
    }
});

$("*[data-open-stppg]").on("click", function () {
    var arr = $(this).data("open-stppg");
    var target = arr.split(" ");
    for (var i = 0; i < target.length; i++) {
        $("#" + target[i]).addClass("active");
        if ($("#" + target[i]).find(".styler").length) {
            setTimeout(function () {
                $(".styler").trigger("refresh");
            }, 100);
        }
    }
});

$(document).on("click", '*[data-open*="mdl"]', function () {
    if (!$(this).hasClass("js-mdl-close")) {

        overlayStart();
    }
});
$('*[data-open-stppg*="mdl"]').on("click", function () {
    if (!$(this).hasClass("js-mdl-close")) {
        overlayStart();
    }
});

$(document).on("click", ".js-mdl-close", function () {
    if ($(".mdl-wrap.active").length > 1) {
        if ($(this).hasClass("mdl-wrap")) {
            $(this).removeClass("active");
        } else {
            $(this).closest(".mdl-wrap").removeClass("active");
        }
    } else {
        if ($(this).hasClass("mdl-wrap")) {
            $(this).removeClass("active");
        } else {
            $(this).closest(".mdl-wrap").removeClass("active");
        }

        overlayEnd();
    }
});

$(document).on('click', '.js-mdl-close-all-inner-containers', function(){
    $(this).closest('.mdl-wrap').find('.js-mdl-container').removeClass('active');
});

$(document).on("click", ".js-mdl-close-all", function () {
    let mdl = $(".mdl-wrap.active");
    mdl.removeClass("active");
    $(".mdl-background").removeClass("active");
});

$(document).on("click", ".mdl", function (event) {
    event.stopPropagation();
});

$(document).on("click", ".js-self-close", function () {
    $(this).removeClass("active");
});

$(document).on("click", ".js-self-toggle", function () {
    $(this).toggleClass("active");
});

$(document, '.mdl-wrap').on("click touch", "*[data-drop]", function () {
    var target = $(this).attr("data-drop");
    $(".js-dropdown:not(#" + target + ")").removeClass("active");
    $("*[data-drop]").not(this).removeClass("active");
    if (!$("#" + target).hasClass("active")) {
        $("#" + target).addClass("active");
        $(this).addClass("active");
    } else {
        $("#" + target).removeClass("active");
        $(this).removeClass("active");
    }
});

$(document, '.mdl-wrap').on("mousedown touch", function (event) {
    if ($(event.target).closest("*[data-drop]").length) {
        return;
    }
    $(".js-dropdown").removeClass("active");
    $("*[data-drop]").removeClass("active");
});

$(document, '.mdl-wrap').on("mousedown touch", ".js-dropdown", function (event) {
    if ($(".js-dropdown").hasClass("active")) {
        event.stopPropagation();
    }
});

$(".mdl").on("click", function (event) {
    if ($(".js-dropdown").hasClass("active")) {
        $(".js-dropdown").removeClass("active opened");
    }
});

/* 'js-drop-toggle' class need to use pair with data-toggle */
/* it helps element to behave as dropdown but use data-toggle */
/* prevent bugs when in modal */
$(document, '.mdl-wrap').on("mousedown touch", function (event) {
    if ($(event.target).closest(".js-drop-toggle").length) {
        return;
    }
    $(".js-drop-toggle").removeClass("active");
});

$(document).on("click", "*[data-trigger-by-class]", function () {
    let target = $(this).data("trigger-by-class");
    $(this)
        .closest(".js-trigger-by-class-parent")
        .find(`.${target}`)
        .trigger("click");
});

$(document).on("mouseenter mouseout", "*[data-hover]", function () {
    var target = $(this).attr("data-hover"),
        item = $("#" + target);
    if (!item.hasClass("active")) {
        item.addClass("active");
    } else {
        item.removeClass("active");
    }
});

$(document).on("mouseenter", "*[data-hover]", function (event) {
    event.stopPropagation();
    var element = $(this),
        target = $(this).attr("data-hover");
    definePoistion(element, target, "tooltip");
});

$(document).on("click touch", "*[data-popover-position]", function (event) {
    event.stopPropagation();
    var element = $(this),
        target = $(this).attr("data-drop");
    definePoistion(element, target, "popover");
});


$(document, '.mdl-wrap').on("click", "*[data-toggle]", function (event) {
    event.stopPropagation();
    var toggleIndicator = true;
    if (toggleIndicator == true) {
        toggleIndicator = false;

        var target = $(this).attr("data-toggle");
        if (!$("#" + target).hasClass("active")) {
            $("#" + target).addClass("active");
            $(this).addClass("active");
            setTimeout(function () {
                toggleIndicator = true;
            }, 250);
        } else {
            $("#" + target).removeClass("active");
            $(this).removeClass("active");
            setTimeout(function () {
                toggleIndicator = true;
            }, 250);
        }
    }
});

$(document).on("click", ".js-toggle-closest-btn", function (event) {
    event.stopPropagation();
    let parent = $(this).closest(".js-toggle-closest-parent");
    $(this).toggleClass("active");
    parent.toggleClass("active");
});

$(document).on("click", "*[data-slide]", function (event) {
    event.stopPropagation();
    if (slideToggleIndicator == true) {
        slideToggleIndicator = false;
        var target = $(this).attr("data-slide");
        if (!$("#" + target).hasClass("active")) {
            $("#" + target).slideDown(250, function () {
                $(this).addClass("active");
                slideToggleIndicator = true;
            });
        } else {
            $("#" + target)
                .removeClass("active")
                .slideUp(250, function () {
                    // $(this).removeClass('active');
                    slideToggleIndicator = true;
                });
        }
    }
    if ($("#" + target).find(".styler").length) {
        setTimeout(function () {
            $(".styler").trigger("refresh");
        }, 100);
    }
    slideToggleIndicator;
});

$(document).on("click", "*[data-remove]", function () {
    var target = $(this).attr("data-remove");
    $("#" + target).remove();
});

// set id for remove to element with data-remove attribute
$(document).on("click", "*[data-set-id-for-remove]", function () {
    let arr = $(this).data("set-id-for-remove"),
        splitArr = arr.split(" "),
        elemToRemoveId = splitArr[0],
        elemToSetRemoveId = splitArr[1];
    $(`#${elemToSetRemoveId}`).attr("data-remove", elemToRemoveId);

    /* for Experience flow - step 4 - location */
    if($(this).hasClass('js-exp-address-delete-btn') && $(this).closest('.js-exp-address-list').find('.js-exp-address').length == 1){
        $(`#${elemToSetRemoveId}`).removeAttr("data-remove");
        $(`#${elemToSetRemoveId}`).attr("data-target", elemToRemoveId);
    }
});

$(document).on("click", ".js-tab", function () {
    if ($(this).hasClass("active")) {
        return;
    } else {
        $(this).parents(".js-tab-parent").find(".js-tab").removeClass("active");
        $(this).addClass("active");
    }
});

$(document).on("click", ".js-tab-deligate", function () {
    if ($(this).hasClass("active")) {
        return;
    } else {
        $(this)
            .parents(".js-tab-parent")
            .find(".js-tab-deligate")
            .removeClass("active");
        $(this).addClass("active");
    }
});

$(document).on("click touch", "*[data-tab]", function () {
    $(this).addClass("active").siblings(".js-tab").removeClass("active");
    var arr = $(this).attr("data-tab");
    var target = arr.split(" ");
    
    for (var i = 0; i < target.length; i++) {
        $("#" + target[i])
            .addClass("active")
            .siblings(".js-tab-section")
            .removeClass("active");
        if ($("#" + target[i]).find(".styler").length) {
            setTimeout(function () {
                $(".styler").trigger("refresh");
            }, 100);
        }
    }

    if($('.js-favorites-tab').length){
        $(document).trigger('favoritesTabClicked');
    }
});

$(document).on("click", "*[data-trigger]", function () {
    var target = $(this).attr("data-trigger");
    $("#" + target).trigger("click");
});

$(document).on("click", ".js-scroll-top", function () {
    $("html,body").animate({ scrollTop: 0 }, 500);
});

$(document).on("click", ".js-remove-closest-target", function () {
    let targetLast = $(this).attr("data-show-on-last"),
        elemToShowOnLast = $(`.${targetLast}`);

    if ($(this).hasClass("js-hide-parent-last")) {
        if (
            $(this).closest(".js-parent-last").find(".js-hide-parent-last")
                .length < 2
        ) {
            $(this).closest(".js-parent-last").removeClass("active");
            if ($(this).is("[data-show-on-last]")) {
                if ($(this).is("[data-show-on-last]")) {
                    elemToShowOnLast.addClass("active");
                }
            }
        }
    }
    $(this).closest(".js-closest-target").remove();
});

$(document).on("click", ".js-hide-closest-target", function () {
    $(this).closest(".js-closest-target-to-hide").removeClass("active");
});

$(document).on("click", ".js-activate-closest-target", function () {
    if($(this).closest('.js-closest-parent')){
        $(this).closest('.js-closest-parent').find('.js-closest-target').addClass('active');
    }

    $(this).closest(".js-closest-target").addClass("active");
});

$(document).on("click", "*[data-set-text-from-field]", function () {
    let arr = $(this).attr("data-set-text-from-field"),
        targets = arr.split(" "),
        fieldText = $(`#${targets[0]}`).val(),
        targetToSetText = $(`#${targets[1]}`);

    targetToSetText.text(fieldText);

    let attr = targetToSetText.attr("href");
    // For some browsers, `attr` is undefined; for others,
    // `attr` is false.  Check for both.
    if (typeof attr !== "undefined" && attr !== false) {
        targetToSetText.attr("href", `mailto:${fieldText}`);
    }
});

$(document).on("click touch", "*[data-scroll]", function () {
    var target = $(this).attr("data-scroll");
    var targetOffsetTop = $("#" + target).offset().top;
    /* 		var wS = window.pageYOffset;
    var scrollDistance = targetOffsetTop + wS; */
    $("html, body").animate({ scrollTop: targetOffsetTop }, 250);
});

$(document).on("click touch", "*[data-scroll-with-offset]", function () {
    const arr = $(this).attr("data-scroll-with-offset").split(" ");
    const target = arr[0];
    const additionalOffset = Number(arr[1]);
    let targetOffsetTop = $("#" + target).offset().top;

    if(additionalOffset){
        targetOffsetTop = targetOffsetTop - additionalOffset;
    }

    $("html, body").animate({ scrollTop: targetOffsetTop }, 250);
});


// close element if click outside
$(document).mousedown(function(event) {
    var $target = $(event.target);
    var _this = this;
    while ($(_this).children($target).length || $(_this).find($target).length) {
        _this = $(_this).parent();
    }

    if (!$(_this).is('.js-close-by-click-outside') && !$(_this).is(document.body)) {
        $('.js-close-by-click-outside').removeClass('active');
    }
});
